var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgeingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm-.25 5.853l1.481 1.784a1.001 1.001 0 0 0 1.54-1.278L8.97 5.081a2.996 2.996 0 0 0-2.31-1.084H5.534a3.003 3.003 0 0 0-2.571 1.456L1.14 8.484a1 1 0 0 0 .34 1.372 1 1 0 0 0 1.372-.34l.897-1.488V15a.999.999 0 1 0 2 0v-4h.5v4a.999.999 0 1 0 2 0V7.353zM11 11.75a.25.25 0 0 1 .25-.25.25.25 0 0 1 .25.25v3.5c0 .416.334.75.75.75s.75-.334.75-.75v-3.5a1.751 1.751 0 0 0-3.5 0V12c0 .416.334.75.75.75s.75-.334.75-.75v-.25z",
    fill: "#5A0085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeingIcon);
export default __webpack_public_path__ + "static/media/ageingIcon.64e05dfde52b33cdb3f8d5d7a6100738.svg";
export { ForwardRef as ReactComponent };